import { useMemo, useState } from 'react';
import { CommonProperties } from '../../common/common.interfaces';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { BoxSeam, PersonCircle } from 'react-bootstrap-icons';
import { useUserContext } from '../../user/UserContext';
import ListingsByAccount from './by-account/ListingsByAccount';
import '../css/listings.css'
import ListingsByProduct from './by-product/ListingsByProduct';
import { EnvironmentSelection } from '../../common/components/EnvironmentSelection';
import { CustomWarning } from '../../common/components/CustomWarning';
interface ListingsProps extends CommonProperties {}

export default function Listings(props: ListingsProps){
  const {userData} = useUserContext()
  const [environment, setEnvironment] = useState<'production' | 'development'>('production')
  
  const view = useMemo(() => {
    return <div>
      <div id='top'></div>
      <div className='beacon-card'>
        <table className='beacon-table'>
          <tbody>
            <tr>
              <td><span className='beacon-header'>Listings</span></td>
            </tr>
            <tr>
              <td><span className='beacon-label'>Manage account/integration level listings, product level listings, marketplace availability, and inventory settings for listings.</span></td>
            </tr>
            {userData.roles.includes('admin') &&
              <tr>
                <td>
                  <EnvironmentSelection environment={environment} setEnvironment={setEnvironment} />
                </td>
              </tr>
            }
            {/* REMOVE SECTION AFTER UX TESTING */} 
            <tr>
              <td>
                <CustomWarning>
                  <span className='beacon-label' style={{color: 'rgb(0, 0, 0)'}}>BETA VERSION: THIS IS A READ-ONLY VIEW OF LISTINGS FOR TESTING PURPOSES.<br/>NOTHING IN MISSION CONTROL WILL BE UPDATED WHEN ACTIONS, OR FIELDS, ARE CLICKED OR CHANGED.</span>
                </CustomWarning>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Tabs>
        <TabList>
          <Tab key='byProductTab'><span className='beacon-header'><BoxSeam size={25}/> BY PRODUCT</span></Tab>
          <Tab key='byAccountTab'><span className='beacon-header'><PersonCircle size={25}/> BY ACCOUNT</span></Tab>
        </TabList>
        <TabPanel key='byProductTabPanel'>
          <ListingsByProduct environment={environment} />
        </TabPanel>
        <TabPanel key='byAccountTabPanel'>
          <ListingsByAccount environment={environment} />
        </TabPanel>
      </Tabs>
    </div>
  }, [props, environment])

  return view
}